// DashboardBranchBarChart.tsx
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
  ResponsiveContainer,
} from "recharts";

interface BranchMetric {
  yaazh_branch: string;
  login_ftd?: string;
  login_mtd?: string;
  login_ytd?: string;
  last_month_login_ftd?: string;
  last_month_login_mtd?: string;
  last_month_login_ytd?: string;
}
interface Props { data: BranchMetric[]; range: "FTD" | "MTD" | "YTD"; }

const DashboardBranchBarChart: React.FC<Props> = ({ data, range }) => {
  if (!Array.isArray(data) || data.length === 0) {
    return <div>No data available to display chart</div>;
  }

  const chartData = data.map((item) => {
    let current = 0, lastMonth = 0;
    switch (range) {
      case "FTD":
        current = parseInt(item.login_ftd || "0", 10);
        lastMonth = parseInt(item.last_month_login_ftd || "0", 10);
        break;
      case "MTD":
        current = parseInt(item.login_mtd || "0", 10);
        lastMonth = parseInt(item.last_month_login_mtd || "0", 10);
        break;
      case "YTD":
        current = parseInt(item.login_ytd || "0", 10);
        lastMonth = parseInt(item.last_month_login_ytd || "0", 10);
        break;
    }
    return {
      branch: item.yaazh_branch,
      "This Month": current,
      "Last Month": lastMonth,
    };
  });

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={chartData}
        margin={{ top: 20, right: 30, bottom: 5, left: 10 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="branch" />
        <YAxis allowDecimals={false} />
        <Bar dataKey="Last Month" fill="#ef6c00" barSize={30}>
          <LabelList dataKey="Last Month" position="top" />
        </Bar>
        <Bar dataKey="This Month" fill="#42a5f5" barSize={30}>
          <LabelList dataKey="This Month" position="top" />
        </Bar>
        <Legend />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default DashboardBranchBarChart;
